/*
 * App Messages
 *
 * The <head> defaults every page inherits unless it sets its own.
 */

export const appScope = 'app.containers.app';

export const appMessages = {
  defaultTitle: {
    id: `${appScope}.defaultTitle`,
    defaultMessage: 'Réservez vos voyages responsables en 3 clics',
    en: 'Book your responsible journeys in 3 clicks',
    es: 'Reserva tus viajes responsables en 3 clics',
    it: 'Prenota i tuoi viaggi responsabili in 3 clic',
    de: 'Buchen Sie Ihre nachhaltigen Reisen in 3 Klicks',
    nl: 'Boek je verantwoorde reizen in 3 klikken',
  },
  defaultDescription: {
    id: `${appScope}.defaultDescription`,
    defaultMessage:
      'Comparez, combinez et réservez tous vos voyages en train, bus et covoiturage sur une plateforme unique.',
    en: 'Compare, combine and book all your train, bus and carpool journeys on a single platform.',
    es: 'Compara, combina y reserva todos tus viajes en tren, autobús y coche compartido en una única plataforma.',
    it: "Confronta, combina e prenota tutti i tuoi viaggi in treno, autobus e carpooling su un'unica piattaforma.",
    de: 'Vergleichen, kombinieren und buchen Sie alle Ihre Reisen mit Zug, Bus und Mitfahrgelegenheit auf einer einzigen Plattform.',
    nl: 'Vergelijk, combineer en boek al je reizen met trein, bus en carpool op één platform.',
  },
};
